// searchbar.tsx
import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, setSearchTerm }) => {
  const [localSearchTerm, setLocalSearchTerm] = useState<string>(searchTerm);

  useEffect(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);

  const debouncedSetSearchTerm = useCallback(
    debounce((value: string) => {
      setSearchTerm(value);
    }, 300),
    [setSearchTerm]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchTerm(value);
    debouncedSetSearchTerm(value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchTerm(localSearchTerm); // Immediate search on Enter
    }
  };

  return (
    <div className="relative">
      <input
        className="block w-full p-3 pr-10 rounded-lg bg-lightblue-100 text-sm text-grease-100 placeholder-gray-400 focus:outline-none"
        placeholder="Search by keyword"
        value={localSearchTerm}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
      />
      <span className="absolute inset-y-0 right-3 flex items-center st-search text-lightgray-200" />
    </div>
  );
};

export default SearchBar;